import React from 'react';
import Grid from '@cx/ui/Grid';
import Col from '@cx/ui/Col';
import Panel from 'react-bootstrap/lib/Panel';
import Crudley from '../../assets/crudley.png';

const NotFound = () => {
  return (
    <Grid fluid className="template-page-wrapper page-wrapper__content-only">
      <Col sm={12} md={12} lg={12}>
        <Panel>
          <div className="template-content-wrapper content-wrapper__content-only">
            <h1>Page not found!</h1>
            <img src={Crudley} alt="" />
          </div>
        </Panel>
      </Col>
    </Grid>
  );
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/pages/NotFound.js